module.exports = __webpack_public_path__ + "img/Icon (1).c4873bec.svg";